import ResizableContainer from "../core/ResizableContainer";
import ResizableScene from "../core/ResizableScene";
import { DecorationData } from "./DecorationData";
import DraggableButton from "./DraggableButton";

type DraggableButtonCallback = (ptr: Phaser.Input.Pointer, dragging: boolean) => any;

export default class DecorationButton extends ResizableContainer {
	static readonly ON_CLICK = "onClick";

	protected button: DraggableButton;
	protected decorationIcon: Phaser.GameObjects.Image;
	protected lockedOverlay: Phaser.GameObjects.Container;

	// protected spawnedObject: Decoration = null;

	protected decorationData: DecorationData;
	public get decoData(): DecorationData {
		return this.decorationData;
	}

	protected _inputEnabled = true;
	protected callback?: DraggableButtonCallback;
	baseImage: string;
	index: number;

	static ON_DRAG_VERTICAL = "onDragVertical";

	dragStart: Phaser.Math.Vector2;
	horizontalEnabled = true;
	dragging = false;

	constructor(scene: ResizableScene, decoration: DecorationData, baseImage: string, index: number, callback?: () => void, context?: CallbackContext) {
		super(scene, 0, 0);
		this.decorationData = decoration;
		this.index = index;
		this.baseImage = baseImage;
		this.button = new DraggableButton(scene, 0, 0, baseImage);
		this.add(this.button);
		this.setSize(this.button.width, this.button.height);

		// this.decorationIcon = this.scene.add.image(0, 0, decoration.image + "-thumb");
		if (decoration.thumb) {
			this.decorationIcon = this.scene.add.image(0, 0, decoration.thumb);
		} else {
			this.decorationIcon = this.scene.add.image(0, 0, decoration.id);
		}
		this.add(this.decorationIcon);

		this.lockedOverlay = scene.add.container(0, 0);
		this.add(this.lockedOverlay);

		const lockedIcon = scene.add.image(0, 0, "dollInUse");
		const lockWidth = this.button.displayWidth / lockedIcon.width;
		const lockHeight = this.button.displayHeight / lockedIcon.height;
		lockedIcon.setScale(lockWidth, lockHeight);
		// lockedIcon.setScale(0.85);
		this.lockedOverlay.add(lockedIcon);

		this.setDecoration(decoration);
		this.setCallback(callback, context);
		this.button.on(DraggableButton.ON_CLICK, this.onClick, this);
		this.button.on(DraggableButton.ON_DRAG_START, this.onDragStart, this);
		this.button.on(DraggableButton.ON_DRAG, this.onDragMove, this);
		this.button.on(DraggableButton.ON_DRAG_END, this.onDragEnd, this);
	}

	protected onClick(ptr: Phaser.Input.Pointer): void {
		if (this._inputEnabled && this.callback){
			this.callback(ptr, false);
			this.playSelectAnim();
		}
	}

	playSelectAnim(): void {
		if (this.button.texture.key == this.baseImage) return;
		const timeline = this.scene.tweens.createTimeline();
		timeline.add({
			targets: this,
			angle: this.angle - 3,
			duration: 75,
			ease: Phaser.Math.Easing.Quadratic.Out,
		});
		timeline.add({
			targets: this,
			angle: 4,
			duration: 150,
			ease: Phaser.Math.Easing.Quadratic.InOut,
		});
		timeline.add({
			targets: this,
			angle: 0,
			duration: 75,
			ease: Phaser.Math.Easing.Back.Out,
		});

		this.scene.tweens.add({
			targets: this,
			scale: 1.1,
			duration: 300,
			ease: Phaser.Math.Easing.Back.Out,
		})
		timeline.play();
	}

	protected onDragStart(ptr: Phaser.Input.Pointer): void {
		this.dragStart = ptr.position.clone();
	}

	protected onDragMove(ptr: Phaser.Input.Pointer): void {
		if (this.dragging) return;
		const pos = ptr.position.clone();
		const delta = pos.subtract(this.dragStart);
		if (Math.abs(delta.x) > 30 && this.horizontalEnabled) {
			this.dragging = true;
			if (this._inputEnabled && this.callback) {
				this.callback(ptr, true);
				this.playSelectAnim();
			}
		}
		else if (Math.abs(delta.y) > 30 || !this.horizontalEnabled) {
			this.dragging = true;
			this.emit(DecorationButton.ON_DRAG_VERTICAL, ptr);
		}
	}

	protected onDragEnd(): void {
		this.dragging = false;
	}

	setButtonTexture(texture: string){
		this.button.setTexture(texture);
	}

	setCallback(callback: DraggableButtonCallback, context?: any): void {
		if (!callback) return;
		if (context) callback = callback.bind(context);
		this.callback = callback;
	}

	removeCallback(): void {
		this.callback = undefined;
	}

	setDecoration(decoration: DecorationData): void {
		this.decorationData = decoration;

		const width = this.width * 0.8;
		const height = this.height * 0.8;
		// this.decorationIcon.setTexture(decoration.image + "-thumb");
		if (decoration.thumb) this.decorationIcon.setTexture(decoration.thumb);
		else this.decorationIcon.setTexture(decoration.id);

		if (this.decorationData.tint) this.decorationIcon.tint = Number.parseInt(decoration.tint);
		else this.decorationIcon.clearTint();

		this.lockedOverlay.setVisible(false);
	}

	lockButton(lock: boolean): void {
		this.enableInput(!lock);
		this.lockedOverlay.setVisible(lock);
		if (!lock) {
			this.setScale(1);
			this.setButtonTexture(this.baseImage);
		}
	}

	destroy(): void {
		if (this.button) {
			this.button.off(DraggableButton.ON_DRAG_START);
			this.button.off(DraggableButton.ON_DRAG);
			this.button.off(DraggableButton.ON_DRAG_END);
			this.button.off(DraggableButton.ON_CLICK);
		}
		super.destroy();
	}

	get inputEnabled(): boolean {
		return this._inputEnabled;
	}

	enableInput(enable: boolean): void {
		// if (enable && !this.decorationData.unlocked) return;
		this._inputEnabled = enable;
		this.horizontalEnabled = enable;
		// this.button.enableInput(enable);
	}

	enableButtonInput(enable: boolean): void {
		this.button.enableButtonInput(enable);
	}

	enableDragging(enable: boolean): void {
		this.button.enableDragging(enable);
	}
}
